import React from 'react'
import { Box, Center, Divider, Flex,Img, Stack, Text, VStack } from '@chakra-ui/react';
import img from "../../Assets/Images/photo.jpg";
import Adrees from "../../Assets/Images/Adrees.jpeg";
import hammad from "../../Assets/Images/hammad.jpeg";
import man from "../../Assets/Images/man.png";
import bassam from "../../Assets/Images/bassam.jpeg";
import saad from "../../Assets/Images/saad.jpg";

function Advisors() {
  const textStyle = {
    color: "#1F508B",
    fontSize: "18px",
    fontWeight: "300",
    lineHeight: "1.5rem"
  };
  const headingStyle = {
    color: "#1F508B",
    fontSize: "30px",
    fontWeight: "300",
    lineHeight: "1.5rem"
  };
  return (
    <>
      <Center>
        <Stack maxW={"1010px"} alignItems={"center"} mt={"100px"}>
          <Box textAlign={"center"}>
            <Text {...headingStyle}>Support Team - We can help you with your </Text>
            <Text {...headingStyle} mt={"18px"}>tokenized real estate investment</Text>
            <Center>
              <Divider alignItems={"center"} mt={"40px"} mb={"10px"} width={"25%"} borderColor={"#1F508B"} /> </Center>
          </Box>
          <Box>
            <Center>
              <Box flexDirection={"column"} mt={"100px"}>
                <Text {...headingStyle}>Advisors</Text>
                <Divider alignItems={"center"} mt={"30px"} mb={"60px"} borderColor={"#1F508B"} />
              </Box>
            </Center>
            <Flex align={"center"} justifyContent={"center"} gap={"100px"} mb={"50px"} flexWrap={"wrap"}>
              <VStack>
                <Img boxShadow={"lg"} borderRadius='full' boxSize='180px' alt='ceo' border={"12px solid white"} src={Adrees} _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...textStyle} mt={"20px"}>Adrees Shakeel</Text>
                <Text {...textStyle} mt={"1px"}>CRE Entrepreneur</Text>
              </VStack>
              <VStack>
                <Img boxShadow={"lg"} borderRadius='full' boxSize='180px' alt='ceo' border={"12px solid white"} src={hammad} _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...textStyle} mt={"20px"}>Hammad Mubeen</Text>
                <Text {...textStyle} mt={"1px"}>Chairman of Starlight REIT</Text>
              </VStack>
              <VStack>
                <Img boxShadow={"lg"} borderRadius='full' boxSize='180px' alt='ceo' border={"12px solid white"} src={man} _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...textStyle} mt={"20px"}>Zain Yazdan</Text>
                {/* <Text {...textStyle} mt={"1px"}>C.P.A.</Text> */}
                <Text {...textStyle} mt={"1px"}>Financial Control</Text>
              </VStack>
              <VStack>
                <Img boxShadow={"lg"} borderRadius='full' boxSize='180px' alt='ceo' border={"12px solid white"} src={bassam} _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...textStyle} mt={"20px"}>Bassam Monib</Text>
                <Text {...textStyle} mt={"1px"}>Family Office RE Executive</Text>
              </VStack>
              <VStack>
                <Img boxShadow={"lg"} borderRadius='full' boxSize='180px' alt='ceo' border={"12px solid white"} src={saad} _hover={{ transform: "scale(1.1)", transition: "transform 0.3s ease" }} />
                <Text {...textStyle} mt={"20px"}>Saad Majeed</Text>
                <Text {...textStyle} mt={"1px"}>Owner at Assured Med Supply</Text>
              </VStack>
            </Flex>
          </Box>
        </Stack>
      </Center><Divider mb={"20px"} mt={"40px"} />
    </>
  )
}

export default Advisors